export default __webpack_public_path__ + "static/media/headerBg.c0c7eee9.jpg";